import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  /* Add some additional styles if needed */
  min-height: 100vh;
`;

export { Wrapper };
